module.exports = __webpack_public_path__ + "images/embed/growl4rails/body_hi.png";